module.exports = __webpack_public_path__ + "static/media/blockFi.9d7d7941.svg";